import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import useDateFormats from 'containers/LanguageProvider/useDateFormats.js';
import UserText from 'components/media/UserText/Loadable.js';
import messages from './messages.js';

function ConsentMeta(props) {
  const { item } = props;
  const { lastModified, lastModifiedBy } = item;
  const { dateTimeFormat } = useDateFormats();
  if (!lastModified) {
    return null;
  }
  return (
    <div className="d-flex flex-column align-items-center me-3 text-center">
      <div className="small text-muted lh-1 text-nowrap">{dateTimeFormat.format(lastModified)}</div>
      <div className="small text-muted lh-sm">{lastModifiedBy ? <UserText inline>{lastModifiedBy}</UserText> : <FormattedMessage {...messages.unknown} />}</div>
    </div>
  );
}

ConsentMeta.propTypes = {
  item: PropTypes.object,
};

export default ConsentMeta;
